/* eslint-disable no-unused-expressions */
import { createSlice } from '@reduxjs/toolkit';
// api
// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  school: {},
  webcamera: false,

  isLogout: false,
};

const slice = createSlice({
  name: 'interview-merchant',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    setSchool(state, action) {
      state.isLoading = false;
      state.school = action.payload;
    },

    setWebcamera(state, action) {
      state.isLoading = false;
      state.webcamera = action.payload;
    },

    setLogout(state, { payload }) {
      state.isLogout = payload;
    },
  },
});

// Reducer
export default slice.reducer;

export const { setSchool, setWebcamera, setLogout } = slice.actions;

// ----------------------------------------------------------------------
